import "./DaShell.css";
import PropTypes from "prop-types";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";

const DaShell = ({ children }) => {
  return (
    <div className="da-shell-wrapper">
      <div className="da-header">
        <img src="/ciam/v1/static/images/da/worldline-logo-horizontal.svg" alt="Worldline logo" />
      </div>

      <div className="da-shell-bg">{children}</div>

      <footer className="da-footer">
        <span className="da-footer-text">
          <Translate tKey={T_KEYS.DA.SHELL.COPYRIGHT} />
        </span>
        <span className="da-footer-text">
          <Translate tKey={T_KEYS.DA.SHELL.PRIVACY} />
        </span>
        <span className="da-footer-text">
          <Translate tKey={T_KEYS.DA.SHELL.TERMS} />
        </span>
      </footer>
    </div>
  );
};

DaShell.propTypes = {
  children: PropTypes.node,
};

export { DaShell };
